import { FormControlError } from "@/components/shared/form-control-error";
import { InputFormControl } from "@/components/shared/input-form-control";
import { RadioCardItem } from "@/components/shared/radio-card-item";
import { Typography } from "@/components/shared/typography";
import { RadioGroup, Skeleton, Textarea, View } from "@/components/ui";
import type { ReportIssueFormReturn } from "@/store/report-issue/forms/useReportIssueForm";
import { usePackageIssueDetailsStore } from "@/store/report-issue/package-issue/issueDetails";
import { useEffect, useId } from "react";
import { Controller } from "react-hook-form";

export function ReportIssueForm({ form }: { form: ReportIssueFormReturn }) {
  const { data, loading } = usePackageIssueDetailsStore();

  useEffect(() => {
    if (data) {
      const [firstReason] = data;
      form.setValue("reason", firstReason?.value ?? "");
    }
  }, [data]);

  const reasonId = useId();

  return (
    <View className="mt-4 flex flex-col gap-1">
      <Controller
        control={form.control}
        name="reason"
        render={({
          field: { onChange, value, disabled },
          fieldState: { error },
        }) => (
          <View>
            <Typography variant="label-sm">Reason*</Typography>
            <RadioGroup id={reasonId} value={value} onValueChange={onChange}>
              {loading ? (
                <View className="space-y-2">
                  <Skeleton className="h-6 w-full" />
                </View>
              ) : data && data?.length > 0 ? (
                <View className="space-y-2">
                  {data?.map((option) => (
                    <RadioCardItem
                      key={option.value}
                      label={option.label}
                      value={option.value}
                      selected={option.value === value}
                      disabled={disabled}
                      onChange={onChange}
                    />
                  ))}
                </View>
              ) : (
                <View className="space-y-2">
                  <Typography variant="body-sm">No reasons found</Typography>
                </View>
              )}
            </RadioGroup>
            <FormControlError error={error?.message} />
          </View>
        )}
      />

      <InputFormControl
        name="comment"
        label="Comment*"
        className="mt-3"
        control={form.control}
        component={Textarea}
        componentProps={{
          placeholder:
            "Please provide a brief description of the issue you are experiencing",
        }}
      />
    </View>
  );
}
